import { rest } from 'utils';

export default {
  create: ({ dcId, serverId, properties }) => rest.post({ url: `datacenters/${dcId}/servers/${serverId}/nics`, body: { properties } }),
  get: ({ dcId, serverId, nicId }) => rest.get({ url: `datacenters/${dcId}/servers/${serverId}/nics/${nicId}?depth=4` }),
  getAll: ({ dcId, serverId }) => rest.get({ url: `datacenters/${dcId}/servers/${serverId}/nics?depth=4` }),
  update: ({
    dcId, serverId, nicId, properties,
  }) => rest.put({ url: `datacenters/${dcId}/servers/${serverId}/nics/${nicId}`, body: { properties } }),
  delete: ({ dcId, serverId, nicId }) => rest.delete({ url: `datacenters/${dcId}/servers/${serverId}/nics/${nicId}` }),
  firewallRuleAdd: ({
    dcId, serverId, nicId, properties,
  }) => rest.post({ url: `datacenters/${dcId}/servers/${serverId}/nics/${nicId}/firewallrules`, body: { properties } }),
  firewallRuleGetAll: ({ dcId, serverId, nicId }) => rest.get({ url: `datacenters/${dcId}/servers/${serverId}/nics/${nicId}/firewallrules?depth=4` }),
  firewallRuleGet: ({
    dcId, serverId, nicId, ruleId,
  }) => rest.get({ url: `datacenters/${dcId}/servers/${serverId}/nics/${nicId}/firewallrules/${ruleId}?depth=4` }),
  firewallRuleDelete: ({
    dcId, serverId, nicId, ruleId,
  }) => rest.delete({ url: `datacenters/${dcId}/servers/${serverId}/nics/${nicId}/firewallrules/${ruleId}` }),
  firewallRuleUpdate: ({
    dcId, serverId, nicId, ruleId, properties,
  }) => rest.put({ url: `datacenters/${dcId}/servers/${serverId}/nics/${nicId}/firewallrules/${ruleId}`, body: { properties } }),
  flowlogAdd: ({
    dcId, serverId, nicId, properties,
  }) => rest.post({ url: `datacenters/${dcId}/servers/${serverId}/nics/${nicId}/flowlogs`, body: { properties } }),
  flowlogGetAll: ({ dcId, serverId, nicId }) => rest.get({ url: `datacenters/${dcId}/servers/${serverId}/nics/${nicId}/flowlogs?depth=4` }),
  flowlogGet: ({
    dcId, serverId, nicId, flowlogId,
  }) => rest.get({ url: `datacenters/${dcId}/servers/${serverId}/nics/${nicId}/flowlogs/${flowlogId}?depth=4` }),
  flowlogDelete: ({
    dcId, serverId, nicId, flowlogId,
  }) => rest.delete({ url: `datacenters/${dcId}/servers/${serverId}/nics/${nicId}/flowlogs/${flowlogId}` }),
  flowlogUpdate: ({
    dcId, serverId, nicId, flowlogId, properties,
  }) => rest.put({ url: `datacenters/${dcId}/servers/${serverId}/nics/${nicId}/flowlogs/${flowlogId}`, body: { properties } }),
};
